const state = {
  startDate: '',
  endDate: '',
  tranType: 1,
  pageNo: 1,
  province: '',
  list: [],
  info: {},
  checked: 0,
  orders: [],
  orderPageNo: 1,
  type: '1'
}

const mutations = {
  SET_PROVINCE(state, province) {
    state.province = province
  },
  SET_DATA(state, { startDate, endDate, tranType, pageNo, list, type }) {
    state.startDate = startDate
    state.endDate = endDate
    state.tranType = tranType
    state.pageNo = pageNo + 1
    state.list = list
    state.type = type
  },
  NEXT_PAGE(state) {
    state.pageNo += 1
  },
  CHECKED(state, value) {
    state.checked = value
  },
  ADD_LIST(state, list) {
    state.list = state.list.concat(list)
    state.pageNo += 1
  },
  SET_INVOICE_INFO(state, info) {
    state.info = info
  },
  ADD_ORDERS(state, orders) {
    state.orders = state.orders.concat(orders)
    state.orderPageNo += 1
  },
  RESET_ORDERS(state) {
    state.orders = []
    state.orderPageNo = 1
  },
  RESET_ORDER_PAGENO(state) {
    state.orderPageNo = 1
  }
}

const actions = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
